export default __webpack_public_path__ + "static/media/top_arrow.8a50f553.svg";